import styles from './NativeSeparator.module.css';

export function NativeSeparator() {
  return <div className={styles.root} />;
}
